import { PunctualityReportRepository } from '@src/main/modules/reports/punctuality/domain/punctuality-report.repository';

export const softDeletePunctualityReport = async (
  repository: PunctualityReportRepository,
  formId: string,
): Promise<void> => await repository.softDelete(formId);
